import { render, staticRenderFns } from "./ProjectEditor.vue?vue&type=template&id=28186352&"
import script from "./ProjectEditor.vue?vue&type=script&lang=js&"
export * from "./ProjectEditor.vue?vue&type=script&lang=js&"
import style0 from "./ProjectEditor.vue?vue&type=style&index=0&id=28186352&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports